module.exports = __webpack_public_path__ + "img/Newbie_Bow_01_Classic.c9ceb62a.png";